import { render, staticRenderFns } from "./AdminOpportunities.vue?vue&type=template&id=3a88ab35"
import script from "./AdminOpportunities.vue?vue&type=script&lang=ts"
export * from "./AdminOpportunities.vue?vue&type=script&lang=ts"
import style0 from "./AdminOpportunities.vue?vue&type=style&index=0&id=3a88ab35&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports